import { addIntersectionItem } from '../util'

let loaded = false

export function gmap(selector = '.js-map', context = document) {
    const mapElement = context.querySelector(selector)
    if (!mapElement) {
        return
    }

    if (typeof window.google !== 'undefined') {
        initMap(mapElement)
        return
    }

    addIntersectionItem(mapElement, ({ el }, entry) => {
        if (loaded || !entry.isIntersecting) {
            return
        }

        loaded = true
        loadjs(['//maps.googleapis.com/maps/api/js?key=' + window.GOOGLE_MAP_KEY], {
            success: () => {
                initMap(el)
            }
        })
    })
}

function initMap(selector) {
    if (typeof window.google === 'undefined') {
        setTimeout(() => {
            initMap(selector)
        }, 1250)
        return
    }

    const mapElements = document.querySelector('.js-map')
    if (!mapElements) {
        return
    }

    let { lat, lng, zoom } = mapElements.dataset
    zoom = +zoom || 17
    const { Map, Marker } = window.google.maps
    const latLng = {
        lat: +lat || 51.235124,
        lng: +lng || -1.118506
    }
    let center = {
        lat: latLng.lat,
        lng: latLng.lng
    }
    if (window.innerWidth <= 786) {
        center = latLng
    }

    const customIcon = {
        url: '/application/themes/the_escape/assets/images/logo.svg',
        size: new window.google.maps.Size(170, 170),
        scaledSize: new google.maps.Size(50, 50),
        origin: new window.google.maps.Point(0, 0),
        anchor: new window.google.maps.Point(25, 25)
    }

    const map = new Map(mapElements, {
        zoom,
        center: center,
        scrollwheel: false,
        gestureHandling: 'cooperative'
    })

    new Marker({
        position: latLng,
        map,
        title: 'Benyon Estate',
        icon: customIcon
    })
}
window.initMap = initMap
